<!-- page 0 rate company -->
@if (activePage === 0) {
<div
  class="modal-body text-center m-4 d-flex flex-column align-items-center animation"
>
  <img loading="lazy"  src="assets/images/salon.jpg" class="salon-img" />
  <h1>
    {{ "rating.rateYourLastExperienceAt" | translate }}
    {{ ratingSettings.branchName }}
  </h1>
  <p class="opacity-50">{{ "rating.shareYourThoughts" | translate }}</p>
  <p-rating [(ngModel)]="ratingSettings.providerRate" [cancel]="false" />
  <div class="w-100">
    <textarea
      rows="5"
      pInputTextarea
      [autoResize]="true"
      [(ngModel)]="ratingSettings.comment"
      class="w-100 border"
    ></textarea>
  </div>
  @if (!numberOfEmployeesWithNonZeroRatings) {
  <p class="link" (click)="goToRateEmployees()">
    {{ "rating.rateEmployees" | translate }} >
  </p>
  } @if (numberOfEmployeesWithNonZeroRatings) {
  <div
    class="w-100 p-5 selected-employees-box d-flex justify-content-between align-items-center"
  >
    <p class="p-0 m-0 d-flex gap-2 w-full">
      <img loading="lazy"  src="assets/icons/true.svg" alt="" />
      {{ numberOfEmployeesWithNonZeroRatings }} Employee/s have been rated
    </p>
    <p class="link p-0 m-0" (click)="goToRateEmployees()">Edit</p>
  </div>
  }
</div>
<div class="modal-footer m-4">
  <div class="item-form-actions__buttons d-flex w-full">
    <button
      type="button"
      (click)="skip()"
      class="btn outline-primary w-50 text-primary-400 bg-transparent border-primary-400 font-regular text-nowrap"
    >
      {{ "common.skip" | translate }}
    </button>
    <button
      type="button"
      (click)="submit()"
      class="btn w-50 text-nowrap m-start-3 btn-primary font-regular text-white"
    >
      {{ "common.submit" | translate }}
    </button>
  </div>
</div>
}

<!-- page 0 rate company -->
@if (activePage === 1) {
<div class="m-4 d-flex gap-2">
  <img loading="lazy" 
    src="assets/icons/arrow-left.svg"
    width="24"
    height="24"
    alt="left-arrow"
    class="cursor-pointer"
    (click)="goToRateCompany()"
    [ngStyle]="{ rotate: common.getLang() === 'ar' ? '180deg' : '' }"
  />
  <h4 class="modal-title">{{ "rating.rateEmployees" | translate }}</h4>
</div>

<div
  class="modal-body text-center m-4 d-flex flex-column align-items-center animation"
>
  @for (item of employeesRatings; track $index) {
  <div class="d-flex align-items-center justify-content-between mb-2 w-full">
    <div class="d-flex align-items-center gap-2">
      <img loading="lazy"  src="assets/images/profile1.png" width="56" height="56" alt="" />
      <div class="d-flex flex-column justify-content-center align-items-start">
        <h6 class="m-0">{{ item.employeeName }}</h6>
        <p class="opacity-50 m-0">{{ item.serviceName }}</p>
      </div>
    </div>
    <p-rating
      [cancel]="false"
      [(ngModel)]="item.employeeRate"
      (ngModelChange)="saveEmployeesRate()"
    />
  </div>
  }
</div>

<div class="modal-footer m-4">
  <div class="item-form-actions__buttons d-flex w-full">
    <button
      type="button"
      (click)="goToRateCompany()"
      class="btn outline-primary w-50 text-primary-400 bg-transparent border-primary-400 font-regular text-nowrap"
    >
      {{ "common.back" | translate }}
    </button>
    <button
      type="button"
      (click)="goToRateCompany()"
      class="btn w-50 text-nowrap m-start-3 btn-primary font-regular text-white"
    >
      {{ "common.save" | translate }}
    </button>
  </div>
</div>

}
